var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "container container-small py-4" },
      [
        _c("Heading", {
          staticClass: "py-4",
          attrs: {
            title: _vm.$t("reset_password_title"),
            routeName: "vignette",
          },
        }),
        !_vm.message
          ? [
              _c("Username", {
                attrs: {
                  title: _vm.$t("label_email"),
                  errorMsg: _vm.errorMsgs.email,
                },
                on: {
                  "unlock-btn": function ($event) {
                    _vm.disableButton = false
                  },
                  input: function ($event) {
                    return _vm.updateEmail($event)
                  },
                },
                model: {
                  value: _vm.email,
                  callback: function ($$v) {
                    _vm.email = $$v
                  },
                  expression: "email",
                },
              }),
              _c(
                "button",
                {
                  staticClass: "btn btn-purple w-100",
                  on: {
                    click: function ($event) {
                      return _vm.reset()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("btn_reset_password")))]
              ),
            ]
          : _vm._e(),
        _vm.message
          ? [
              _c("div", { staticClass: "alert alert-success" }, [
                _vm._v(" " + _vm._s(_vm.message) + " "),
              ]),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }